const isCli = !(typeof process !== 'undefined' && process.versions && process.versions.node);

if (isCli) {
  // eslint-disable-next-line global-require
  module.exports = require('./Wysiwyg.client').default;
} else {
  // eslint-disable-next-line global-require
  module.exports = require('./Wysiwyg.server').default;
}
